import { render, staticRenderFns } from "./CardLargeItem.vue?vue&type=template&id=1e12a3cc"
import script from "./CardLargeItem.vue?vue&type=script&lang=js"
export * from "./CardLargeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports